import useHttpErrorsHandel from "./useHttpHandels/useHttpErrorsHandel";


const { httpErrorsHandel } = useHttpErrorsHandel();
const configQueryReactCodetable = {
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    refetchOnReconnect: true,
    onError: (error: any) => {
        httpErrorsHandel(error);
    }
};

export const configQueryReactSimpleRequest = {
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    refetchOnReconnect: true,
    keepPreviousData: false,
    cacheTime: 0,
    onError: (error: any) => {
        httpErrorsHandel(error);
    }
};
export default configQueryReactCodetable;
